import "../css/Loader.css";

export const Spinner = ({ fullPage = false }) => (
    <div id="app-loader" className={fullPage ? 'loader-full-page' : ''}>
        <div className="loader">
            <div className="square" id="sq1"></div>
            <div className="square" id="sq2"></div>
            <div className="square" id="sq3"></div>
            <div className="square" id="sq4"></div>
            <div className="square" id="sq5"></div>
            <div className="square" id="sq6"></div>
            <div className="square" id="sq7"></div>
            <div className="square" id="sq8"></div>
            <div className="square" id="sq9"></div>
        </div>
    </div>
);

const Loader = ({ children, show, fullPage = false }) => {

    return (
        <>
            {show && <Spinner fullPage={fullPage} />}

            {/* Render wrapped content below */}
            {children}
        </>
    );
};

export default Loader;
